
import React from 'react';
import { Grid, Typography, Link} from '@mui/material';

interface Props {
  viewDocuments: string[];
}

const InfosPdf: React.FC<Props> = ({viewDocuments}) => {
  return (
    <Grid container>
      {viewDocuments.includes('warranty') && (
        <Grid item xs={5} sm={3} sx={{ textAlign: "left", sm:{marginRight: "4px"} }}>
          <Typography  sx={{ fontSize: {sm: "10px", xs: "8px"} }} >
            <Link target="_blank" href={'/document/tableau_garanties.pdf'} download="tableau_garanties.pdf">
              {'Tableau des garanties.pdf'}
            </Link>
          </Typography>
        </Grid>
      )}
     {viewDocuments.includes('ipid') && (
      <Grid item xs={3} sm={2} style={{ textAlign: "left" }}>
        <Typography sx={{ fontSize: {sm: "10px", xs: "8px"} }} >
          <Link target="_blank" href={'/document/ipid_habitation.pdf'} download="ipid.pdf">
            {'Fiche IPID.pdf'}
          </Link>
        </Typography>
      </Grid>
      )}
      {viewDocuments.includes('cg') && (
      <Grid item xs={4} sm={3} style={{ textAlign: "left" }}>
        <Typography sx={{ fontSize: {sm: "10px", xs: "8px"}}} >
          <Link target="_blank" href={'/document/CG_MaMaison_habitation.pdf'} download="conditions_generales.pdf">
            {'Conditions générales.pdf'}
          </Link>
        </Typography>
      </Grid>
      )}
    </Grid>
  );
};

export default InfosPdf;
            